/**
 * Fleet CC DCRP Recovery API
 * Connected Claims Damaged Container Recovery APIs used for handling recovery data.
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpEvent,
} from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { FeaPreEpTradeModel } from '../models/feaPreEpTradeModel';
import { UpdateEpTradeBooking } from '../models/updateEpTradeBooking';

@Injectable()
export class FeaPreService {
  protected basePath = environment.ccdcrp_api_base_url;
  public defaultHeaders = new HttpHeaders();

  constructor(protected httpClient: HttpClient) {}

  /**
   * This API will add EP Trade file attachment to provided case ID
   *
   * @param caseId CaseId
   * @param fileId FileID
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public feaPreCaseIdEpTradeAttachmentFileIdPost(
    caseId: number,
    fileId: number,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<boolean>;
  public feaPreCaseIdEpTradeAttachmentFileIdPost(
    caseId: number,
    fileId: number,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<boolean>>;
  public feaPreCaseIdEpTradeAttachmentFileIdPost(
    caseId: number,
    fileId: number,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<boolean>>;
  public feaPreCaseIdEpTradeAttachmentFileIdPost(
    caseId: number,
    fileId: number,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (caseId === null || caseId === undefined) {
      throw new Error(
        'Required parameter caseId was null or undefined when calling feaPreCaseIdEpTradeAttachmentFileIdPost.'
      );
    }

    if (fileId === null || fileId === undefined) {
      throw new Error(
        'Required parameter fileId was null or undefined when calling feaPreCaseIdEpTradeAttachmentFileIdPost.'
      );
    }

    let headers = this.defaultHeaders;
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<boolean>(
      'post',
      `${this.basePath}/fea-pre/${encodeURIComponent(String(caseId))}/ep-trade-attachment/${encodeURIComponent(String(fileId))}`,
      {
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * This API will fetch EP Trade Stage 2 Data
   *
   * @param caseId CaseId
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public feaPreCaseIdEpTradeDataGet(
    caseId: number,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<FeaPreEpTradeModel>>;
  public feaPreCaseIdEpTradeDataGet(
    caseId: number,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<FeaPreEpTradeModel>>>;
  public feaPreCaseIdEpTradeDataGet(
    caseId: number,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<FeaPreEpTradeModel>>>;
  public feaPreCaseIdEpTradeDataGet(
    caseId: number,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (caseId === null || caseId === undefined) {
      throw new Error(
        'Required parameter caseId was null or undefined when calling feaPreCaseIdEpTradeDataGet.'
      );
    }

    let headers = this.defaultHeaders;
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    return this.httpClient.request<Array<FeaPreEpTradeModel>>(
      'get',
      `${this.basePath}/fea-pre/${encodeURIComponent(String(caseId))}/ep-trade-data`,
      {
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * This API will exclude EP Trade from case
   *
   * @param caseId CaseId
   * @param body List of bol numbers with selected flag
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public feaPreCaseIdEpTradeUpdateBookingsPost(
    caseId: number,
    body?: Array<UpdateEpTradeBooking>,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<any>;
  public feaPreCaseIdEpTradeUpdateBookingsPost(
    caseId: number,
    body?: Array<UpdateEpTradeBooking>,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<any>>;
  public feaPreCaseIdEpTradeUpdateBookingsPost(
    caseId: number,
    body?: Array<UpdateEpTradeBooking>,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<any>>;
  public feaPreCaseIdEpTradeUpdateBookingsPost(
    caseId: number,
    body?: Array<UpdateEpTradeBooking>,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (caseId === null || caseId === undefined) {
      throw new Error(
        'Required parameter caseId was null or undefined when calling feaPreCaseIdEpTradeUpdateBookingsPost.'
      );
    }

    let headers = this.defaultHeaders;
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<any>(
      'post',
      `${this.basePath}/fea-pre/${encodeURIComponent(String(caseId))}/ep-trade/update-bookings`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
